<template>
  <div>
    <Sidebar
      class="p-sidebar-md custom-sidebar"
      :dismissable="true"
      position="right"
      :visible.sync="localShowSidebar"
      @hide="close"
      :style="{ width: '500px' }"
    >
      <div class="sidebar-header p-mb-3">
        <h3><i class="pi pi-map p-mr-2"></i>Sugestão de Rotas</h3>
        <span class="p-text-secondary" v-if="suggestions && suggestions.summary">
          Otimização concluída para {{ suggestions.summary.total_interventions }} serviços
        </span>
      </div>

      <div v-if="loading" class="p-d-flex p-ai-center p-jc-center" style="height: 200px">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>

      <div v-else-if="suggestions && suggestions.summary" class="route-content">

        <div class="p-grid p-mb-3">
          <div class="p-col-6">
            <div class="stat-card success">
              <span class="stat-label">Agendados</span>
              <span class="stat-value">{{ suggestions.summary.scheduled }}</span>
            </div>
          </div>
          <div class="p-col-6">
            <div class="stat-card warning">
              <span class="stat-label">Não Agendados</span>
              <span class="stat-value">{{ suggestions.summary.dropped }}</span>
            </div>
          </div>
        </div>

        <Accordion :multiple="true" :activeIndex="[0]">

          <AccordionTab header="Rotas Definidas">
            <div v-for="(schedule, techId) in enrichedSchedules" :key="techId" class="tech-route-container p-mb-4">

              <div class="tech-header p-p-2 p-d-flex p-ai-center p-jc-between">
                <div class="p-d-flex p-ai-center">
                  <Button
                    icon="pi pi-map-marker"
                    class="p-button-rounded p-button-text p-button-sm p-ml-2"
                    v-tooltip.top="'Visualizar esta rota no mapa'"
                    @click.stop="viewRoute(techId, schedule.route)"
                  />
                  <i class="pi pi-user p-mr-2" style="font-size: 1.2rem"></i>
                  <div>
                    <div class="tech-name">{{ getTechName(techId) }} ({{ techId }})</div>
                    <small>{{ schedule.route.length }} intervenções</small>
                  </div>

                </div>

                <div class="route-time-span" v-if="schedule.route.length > 0">
                  {{ schedule.route[0].arrival }} - {{ schedule.route[schedule.route.length - 1].departure }}
                </div>
              </div>

              <div class="timeline-container p-mt-3">
                <div v-for="(stop, index) in schedule.route" :key="index" class="timeline-item">

                  <div class="time-col">
                    <span class="arrival-time">{{ stop.arrival }}</span>
                    <span class="duration-text">{{ stop.duration_min }} min</span>
                  </div>

                  <div class="divider-col">
                    <div class="line top" v-if="index !== 0"></div>
                    <div class="dot"></div>
                    <div class="line bottom" v-if="index !== schedule.route.length - 1"></div>
                  </div>

                  <div class="content-col p-shadow-1">
                    <div class="p-d-flex p-jc-between p-mb-1">
                      <span class="pat-id">PAT #{{ stop.id }}</span>
                      <span class="pat-status" :class="getStatusClass()">
                        {{ getStatusLabel(stop.details) }}
                      </span>
                    </div>
                    <div class="client-name" v-if="stop.details && stop.details.client">
                      {{ stop.details.client.name }}
                    </div>
                    <div class="pat-address" v-if="stop.details">
                      <i class="pi pi-map-marker p-mr-1"></i>
                      {{ stop.details.entity ? stop.details.entity.city : stop.details.client.city }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </AccordionTab>

          <AccordionTab header="Serviços Não Atribuídos">
            <div class="dropped-container">
              <div class="p-mb-2 p-text-italic text-sm">
                Estes serviços não encaixaram no horário ou raio de ação:
              </div>
              <div class="p-d-flex p-flex-wrap">
                <div
                  v-for="patId in suggestions.dropped_interventions"
                  :key="patId"
                  class="dropped-item p-shadow-1 p-mb-2"
                >
                  <div class="p-d-flex p-ai-center p-jc-between">
                    <span class="dropped-id">PAT #{{ patId }}</span>
                    <i class="pi pi-exclamation-triangle p-text-warning"></i>
                  </div>
                  <div class="dropped-detail" v-if="getPatDetails(patId)">
                     {{ getPatDetails(patId).client.city }}
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>

        </Accordion>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import Sidebar from "primevue/sidebar";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Button from "primevue/button";

export default {
  name: "SuggestionRoute",
  props: ["showSidebar", "suggestions", "interventions", "technicians"],
  components: { Sidebar, Accordion, AccordionTab, Button },
  watch: {
    showSidebar(newVal) {
      this.localShowSidebar = newVal;
    },
    localShowSidebar(newVal) {
      if (!newVal) {
        this.close();
      }
    },
  },
  data() {
    return {
      loading: false,
      localShowSidebar: this.showSidebar,
    };
  },
  computed: {
    enrichedSchedules() {
      if (!this.suggestions || !this.suggestions.schedules) return {};

      const enriched = {};

      Object.keys(this.suggestions.schedules).forEach(techId => {
        const schedule = this.suggestions.schedules[techId];

        const enrichedRoute = schedule.route.map(stop => {
          return {
            ...stop,
            details: this.getPatDetails(stop.id)
          };
        });

        enriched[techId] = {
          ...schedule,
          route: enrichedRoute
        };
      });

      return enriched;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getTechName(techId) {
      if (!this.technicians) return '';
      let detail = this.technicians.find(t => t.tecnico == techId);
      if (detail) {
        return detail.username;
      }
      return '';
    },
    getPatDetails(patId) {
      if (!this.interventions) return null;
      return this.interventions.find(p => p.pat_id === patId);
    },
    getStatusLabel(pat) {
        return pat ? pat.pat_status : 'Desconhecido';
    },
    getStatusClass() {
        return 'status-default';
    },
    viewRoute(techId, routeData) {
      this.close();
      this.$emit("view-route", { techId, route: routeData });
    }
  },
};
</script>

<style scoped>

.sidebar-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.stat-card {
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #dee2e6;
}
.stat-card.success { background-color: #f0fdf4; border-color: #bbf7d0; color: #166534; }
.stat-card.warning { background-color: #fefce8; border-color: #fde047; color: #854d0e; }

.stat-label { display: block; font-size: 0.85rem; font-weight: 600; margin-bottom: 0.25rem; }
.stat-value { font-size: 1.5rem; font-weight: 700; }

.tech-route-container {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.tech-header {
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.tech-name { font-weight: 700; color: #334155; }
.route-time-span { font-size: 0.85rem; background: #e2e8f0; padding: 2px 8px; border-radius: 4px; }

.timeline-container {
  padding: 0 1rem 1rem 1rem;
}

.timeline-item {
  display: flex;
  min-height: 70px;
}

.time-col {
  width: 60px;
  text-align: right;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.arrival-time { font-weight: bold; font-size: 0.9rem; color: #333; }
.duration-text { font-size: 0.75rem; color: #888; }

.divider-col {
  width: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dot {
  width: 12px;
  height: 12px;
  background-color: #3b82f6;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 0 1px #3b82f6;
  z-index: 2;
  margin-top: 4px;
}
.line {
  width: 2px;
  background-color: #e2e8f0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.line.top { top: 0; height: 4px; }
.line.bottom { top: 16px; bottom: 0; }

.content-col {
  flex: 1;
  margin-left: 10px;
  margin-bottom: 15px;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border-left: 3px solid #3b82f6;
}

.pat-id { font-size: 0.8rem; font-weight: bold; color: #64748b; }
.pat-status { font-size: 0.7rem; background: #eee; padding: 2px 6px; border-radius: 4px; }
.client-name { font-weight: 600; font-size: 0.95rem; margin: 4px 0; color: #1e293b; }
.pat-address { font-size: 0.85rem; color: #64748b; }

.dropped-container {
  background-color: #fff1f2;
  padding: 1rem;
  border-radius: 6px;
}
.dropped-item {
  background: white;
  border: 1px solid #fecdd3;
  border-radius: 4px;
  padding: 8px;
  width: 100%;
  margin-bottom: 8px;
}
.dropped-id { font-weight: bold; color: #9f1239; }
.dropped-detail { font-size: 0.85rem; color: #666; margin-top: 2px; }

.custom-sidebar .p-sidebar-content {
  padding: 0 !important;
}
.route-content {
  padding: 1.25rem;
}
</style>